import React from "react";

export interface BarShapeProps {
    height: number;
    width: number;
    x: number;
    y: number;
    fill: string;
    background: { x: number; y: number; width: number; height: number; };
    index: number;
    name: string;
    payload: { name: string, value: number };
    radius: [number, number, number, number];
}


interface ConcentrationInfo {
    fill: [string, string];
    category: "good" | "moderate" | "usg" | "unhealthy" | "very-unhealthy" | "hazardous";
}

const getConcentrationInfo = (value: number): ConcentrationInfo => {
    if(value < 55) {
        return {
            fill: ["#45FF47", "#65C466"],
            category: "good",
        };
    }
    if(55 <= value && value < 155) {
        return {
            fill: ["#FFDE72", "#EFB700"],
            category: "moderate",
        };
    }
    if(155 <= value && value < 255) {
        return {
            fill: ["#FF9D6E", "#FF5300"],
            category: "usg",
        };
    }
    if(255 <= value && value < 355) {
        return {
            fill: ["#FF7B94", "#FF0031"],
            category: "unhealthy",
        };
    }
    if(355 <= value && value < 425) {
        return {
            fill: ["#C572FF", "#9700FF"],
            category: "very-unhealthy",
        };
    }
    return {
        fill: ["#EA728A", "#6C2634"],
        category: "hazardous",
    };
};

// Not a react component (Can't use hooks)
export const BarShape = ({
    height, width, fill, x, y,
    background,
    payload
}: BarShapeProps) => {
    const backgroundBottom = background.y + background.height;
    const gradId = "shapeGrad" + x + "-" + y;
    const clipId = "backgroundClip" + x + "-" + y;

    const info = getConcentrationInfo(payload?.value ?? 0);

    return (
        <React.Fragment>
            <defs>
                <linearGradient
                    id={gradId}
                    x1="0%"
                    x2="0%"
                    y1={`0%`}
                    y2={`100%`}
                >
                    <stop offset="0%" style={{
                        stopColor: info.fill[0],
                        stopOpacity: 1,
                    }}/>
                    <stop offset="100%" style={{
                        stopColor: info.fill[1],
                        stopOpacity: 1,
                    }}/>
                </linearGradient>
                <clipPath id={clipId}>
                    <rect x={background.x} y={background.y} width={background.width} height={background.height}/>
                </clipPath>
            </defs>
            <path
                d={`
                M${x + width / 2 + .500},${y + .500} 
                C${x + width * .78114},${y + .500} ${x + width + .5},${y + width * .22886} ${x + width + .500},${y + width / 2 + .500} 
                V ${backgroundBottom + 0.5} 
                h ${-width + 0.5} 
                V ${y + width / 2 + 0.5} 
                C${x + .5},${y + width * .22886} ${x + width * .22886},${y + .5} ${x + width / 2 + .500},${y + .500} 
                Z`}
                fill={`url(#${gradId})`}
                clipPath={`url(#${clipId})`}
            />

            <line
                x1={x + width / 2}
                x2={x + width / 2}
                y1={y + width / 2}
                y2={backgroundBottom}
                style={{stroke: "rgba(255, 255, 255, 0.8)", strokeWidth: 1}}
            />
            <circle
                r={3}
                cx={x + width / 2}
                fill={"rgba(255,255,255,0.8)"}
                cy={y + width / 2}
            />
        </React.Fragment>
    );
}